import { render, staticRenderFns } from "./HumanResourcesDashboard.vue?vue&type=template&id=228eb44b&scoped=true"
import script from "./HumanResourcesDashboard.vue?vue&type=script&lang=js"
export * from "./HumanResourcesDashboard.vue?vue&type=script&lang=js"
import style0 from "./HumanResourcesDashboard.vue?vue&type=style&index=0&id=228eb44b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228eb44b",
  null
  
)

export default component.exports